import { useState } from "react";
import { Wrapper } from "./styles";

const Switch:React.FC<{active: boolean, onClick: () => void, size?: number}> = props => {
    return (
        <Wrapper active={props.active} onClick={props.onClick} size={props.size ? props.size : 1} />
    );
}
 
export default Switch;